import { Col, Row, Input } from 'antd';
import React from 'react';

const { TextArea } = Input;

const ShipmentCommentBox = ({onTextareaChange , error}) => {
  return (
    <Row style={{ marginBottom: '20px' }}>
    <Col span={24}>
        <TextArea maxLength={500} onChange={onTextareaChange} placeholder="Add comment" style={{ height: "100px", border: "10px solid #F3F3F3", background: "#F3F3F3" }} />
        {error && <p style={{ color: "#ff4d4f", marginBottom: "0px" }}>Please give your valuable comments</p>}
    </Col>
</Row>
  )
}

export default ShipmentCommentBox